import FaIcon from '@components/FaIcon';
import MDBox from '@components/MDBox';
import MDTypography from '@components/MDTypography';
import { Grid } from '@mui/material';
import { FC } from 'react';

interface WatermarkProps {
  isKPI: boolean;
  brandLogo: string;
  isPreview: boolean | undefined;
  onClickRemoveWaterMark: (() => void) | undefined;
}

const Watermark: FC<WatermarkProps> = ({ brandLogo, isKPI, isPreview, onClickRemoveWaterMark }) => (
  <MDBox
    display='flex'
    alignItems='baseline'
    justifyContent='end'
    position='relative'
    columnGap={1}
    mb={1}
    mr={isKPI ? 0 : 2}
  >
    <MDBox component='img' src={brandLogo} alt='Brand' width='1.25rem' />
    <MDTypography variant='sm' color='grey'>
      Powered by DataSquirrel
    </MDTypography>
    {onClickRemoveWaterMark && (
      <MDBox position='absolute' right='-17px' top='-17px'>
        <Grid
          container
          onClick={() => onClickRemoveWaterMark()}
          sx={{
            padding: 1,
            minWidth: '5px',
            maxWidth: '5px',
            cursor: 'pointer'
          }}
          id={isPreview ? 'removeWaterMarkButton' : 'waterMarkCross'}
        >
          <FaIcon
            typographyProps={{ variant: 'xs', color: 'info' }}
            icon='xmark'
          />
        </Grid>
      </MDBox>
    )}
  </MDBox>
);

export default Watermark;
